<template>
  <div class="block-container" v-if="!loading">
    <div class="block-title">
      <div>排行榜</div>
      <!-- <div>
        <van-icon name="arrow"
          @click="showMoreEpisodes"
        />
      </div> -->
    </div>
    <van-tabs
      v-model="tabActive"
      type="card"
      color="#323233"
      background="#fff"
      style="background:#fff"
    >
      <van-tab title="飙升榜">
        <episode-list
          v-if="topRaiseEpisodeIds.length > 0"
          :slug="slug"
          :episode-ids="topRaiseEpisodeIds"
          :show-no-more-hint="false"
        />
      </van-tab>
      <van-tab title="畅销榜">
        <episode-list
          v-if="topSaleEpisodeIds.length > 0"
          :slug="slug"
          :episode-ids="topSaleEpisodeIds"
          :show-no-more-hint="false"
        />
      </van-tab>
      <van-tab title="冷门榜">
        <episode-list
          v-if="topNicheEpisodeIds.length > 0"
          :slug="slug"
          :episode-ids="topNicheEpisodeIds"
          :show-no-more-hint="false"
        />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  import EpisodeList from '../../episode-list.vue'
  import { Tab, Tabs } from 'vant'
  import Vue from 'vue'
  Vue.use(Tab)
  Vue.use(Tabs)

  export default {
    name: "BlockTopEpisodes",
    components: {
      EpisodeList
    },
    data () {
      return {
        loading: true,
        slug: this.$route.params.slug, // show 的 slug
        config: {}, // 设置
        tabActive: 0,
        topSaleEpisodeIds: [],
        topRaiseEpisodeIds: [],
        topNicheEpisodeIds: []
      }
    },
    methods: {
      getConfig: function () {
        let that = this
        let params = {
          show__slug: that.slug
        }
        that.$api.todayRecommendsConfig.list(params).then(res => {
          if (res.data.count > 0) {
            if (res.data.results[0].enable) {
              window.console.log("今日推荐区块已启用")
              that.config = res.data.results[0]
              // that.getTodayRecommends()
            } else {
              window.console.log("今日推荐区块已禁用")
            }
          } else {
            window.console.log("未找到相关配置")
          }
        })
      },
      getTodayRecommends: function () {
        // 获取今日推荐
        let that = this
        let params = {
          slug: that.slug,
          hidden: false,
          limit: 5
        }
        that.$api.episode.list(params).then(res => {
          // window.console.log("获取到今日推荐")
          // window.console.log(res)
          that.items = res.data.results
          let episodeIds = []
          for (let i = 0; i < res.data.results.length; i++) {
            const e = res.data.results[i]
            episodeIds.push(e.id)
          }
          that.episodeIds = episodeIds
        })
      },
      getTopLists: function () {
        // 获取排行榜数据
        let that = this
        // 获取畅销榜
        let params = { slug: 'top-sale-episodes' }
        that.$api.topList.list(params).then(res => {
          window.console.log("获取到畅销榜")
          window.console.log(res)
          if (res.data.count > 0) {
            window.console.log('畅销榜', res.data.results[0].episodes)
            that.topSaleEpisodeIds = res.data.results[0].episodes
          }
        })
        // 获取飙升榜
        params = { slug: 'top-raise-episodes' }
        that.$api.topList.list(params).then(res => {
          window.console.log("获取到飙升榜")
          window.console.log(res)
          if (res.data.count > 0) {
            window.console.log('飙升榜', res.data.results[0].episodes)
            that.topRaiseEpisodeIds = res.data.results[0].episodes
          }
        })
        // 获取冷门榜
        params = { slug: 'top-niche-episodes' }
        that.$api.topList.list(params).then(res => {
          window.console.log("获取到冷门榜")
          window.console.log(res)
          if (res.data.count > 0) {
            window.console.log('冷门榜', res.data.results[0].episodes)
            that.topNicheEpisodeIds = res.data.results[0].episodes
          }
        })
      },
      imageOnLoad: function (e) {
        // window.console.log("imageOnLoad:", e)
        let swipeStyle = this.swipeStyle
        swipeStyle.height = e.imageHeight
        this.swipeStyle = swipeStyle
      },
      swipeChange: function (e) {
        if (e == 0) {
          this.$refs.swipe.resize()
        }
      },
      clickItem: function (episodeId) {
        window.console.log("clickItem:", episodeId)
        this.$router.replace({
          name: 'EpisodeDetail',
          params: {
            episodeId: episodeId
          }
        })
      },
      showMoreEpisodes: function () {
        this.$router.replace({
          name: 'EpisodesAll',
          params: {}
        })
      }
    },
    watch: {
      topSaleEpisodeIds: {
        handler: function (topSaleEpisodeIds) {
          if (topSaleEpisodeIds.length > 0) {
            this.loading = false
          }
        },
        immediate: true
      }
    },
    mounted () {
      this.getConfig()
      this.getTopLists()
      // window.console.log("组件被加载")
    },
    destroyed () {
      // window.console.log("组件被销毁")
    }
  }
</script>

<style lang="css" scoped>
.block-title {
  background: #fff;
  padding: 10px 16px 10px 16px;
  color: #228df6;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.block-container {
  border-top: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
}
</style>
